import { Auth } from 'aws-amplify'

import paymentOptionsJson from  "../../config/paymentOptions.json";

class Payment  {
	constructor(request) {
		this.request = request
		this.endpoint = 'payment'
	}

	async Submit(info) {
		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})

		return this.request.send(
			`${this.endpoint}/webform/submit`,
			'POST',
			info,
			jwtToken,
			undefined,
			{
				"configkey":"618f4670ee72f6e9f11c42fdcc1c3da6"
			}
		)
	}

	async RequestQR(info) {
		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})
		return this.request.send(
			`${this.endpoint}/qrph/hitpay`,
			'POST',
			info,
			jwtToken,
			undefined,
			{
			}
		)
	}

	async QRStatus(requestid) {
		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})
		return this.request.send(
			`${this.endpoint}/status/hitpay`,
			'POST',
			{requestid},
			jwtToken,
			undefined,
			{
			}
		)
	}

	async GetHistory(username, type="payment", statusFilter="", pageOffset=0) {
		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})
		const body = {
			username:username,
			statusfilter:statusFilter,
			pageoffset:pageOffset,
			type:type
		};
		return this.request.send(
			`${this.endpoint}/list`,
			'POST',
			body,
			jwtToken
		)
	}

	async GetPaymentOptions(userinfo, type = "Order", seller = "") {
		// Can add other parameters

		/* Once the api is ready

		let jwtToken
		await Auth.currentSession()
		.then((data)=>{
			jwtToken=data.idToken.jwtToken
		})
		.catch ( (err)=> {

		})

		const body = {

		}
		return this.request.send(
			`${this.endpoint}/<path>`,
			'POST',
			body,
			jwtToken
		)
		*/

		/* Temporary until api is ready */
		const { accountlist, accountlistiamnet } = paymentOptionsJson;
		let betamode = type !== 'Order';

		if (seller.length > 0) {
			betamode = betamode || seller === "negosyoprimeselections";
		}

		return {
			status: "OK",
			data: {
				accountList: betamode ? accountlistiamnet : accountlist
			}
		}
		/* Temporary until api is ready */

	}

}

export default Payment
